'use client';

import type { ReactNode } from 'react';

import { useCurrentUser } from '../../contexts/current-user-context';
import { UiProvider } from '../../contexts/ui-provider';

interface FeatureFlagLoaderProps {
  children: ReactNode;
}

/**
 * Bridges currentUser.enabledFeatures to UiProvider's featureFlags context.
 * Must be rendered inside CurrentUserContextProvider.
 *
 * Also passes loading state so FeatureGatedRoute can wait until flags are hydrated
 * before making redirect decisions.
 */
export function FeatureFlagLoader({ children }: FeatureFlagLoaderProps) {
  const { currentUser, loading } = useCurrentUser();

  const flags = currentUser?.enabledFeatures?.map(f => f.key) || [];

  return (
    <UiProvider featureFlags={flags} featureFlagsLoading={loading}>
      {children}
    </UiProvider>
  );
}
